import GuidGenerator from "@/helpers/guid.generator";

export default class Bill {
    public id: string;
    public date: string;
    // @ts-ignore
    public number: string; 
    // @ts-ignore
    public validNumber: string; 
    // @ts-ignore
    public paymentType: number;
    // @ts-ignore
    public paymentTypeName: string;
    public paymentTypes: any[];
    public price: number;    
    public isPaid: boolean;   
    // @ts-ignore
    public donorId: string; 
    // @ts-ignore
    public donorIdd: string;
    
    constructor(paymentTypes: any[])
    {        
        this.paymentTypes = paymentTypes;
        this.id = GuidGenerator.generate();
        this.date = String(new Date());
        this.price = 0;
        this.isPaid = false;
    }    

    // get paymentType():number {
    //     return this._paymentType;
    // }

    // set paymentType(pt:number) {
    //     this.paymentTypeName = this.paymentTypes.find(t => t.key == pt).value;
    //     this._paymentType = pt;
    // }
}
